module.exports = __webpack_public_path__ + "static/img/thimg1.2e2c682b.png";